import React, { useEffect, useState, useContext } from "react";
import styles from "./UserPanelPage.module.scss";

// import { getUserGames, getUserRank } from "../../utils/api/scoresAPI";
import PlayerStats from "../../components/UserPanel/PlayerStats/PlayerStats";
import LeaderBoard from "../../components/UserPanel/LeaderBoard/LeaderBoard";
import ChangePassword from "../../components/UserPanel/ChangePassword/ChangePassword";

import { LanguageContext } from '../../context/LanguageContext';
// Import des traductions 
import translations from '../../utils/translations/UserPanelTranslations';

const UserPanelPage = () => {

  // Utilisation du contexte de langue global
  const { language, changeLanguage } = useContext(LanguageContext);

  // Accès simplifié aux traductions
  const t = translations[language] || translations.fr;

  const [games, setGames] = useState([]);
  const [rank, setRank] = useState(null);

  useEffect(() => {
    async function fetchData() {
      // const userGames = await getUserGames();
      // const userRank = await getUserRank();
      // setGames(userGames);
      // setRank(userRank);
    }
    fetchData();
  }, []);

  return (
    <div className={styles.userAccount}>
      <h1>{t.userAccountTitle}</h1>
      {/* <PlayerStats games={games} />
      <LeaderBoard rank={rank} />
      <ChangePassword /> */}
      <PlayerStats />
      {/* <LeaderBoard /> */}
      {/* <ChangePassword /> */}
    </div>
  );
};

export default UserPanelPage;